import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-horizontal-divider',
  templateUrl: './horizontal-divider.component.html',
  styleUrls: ['./horizontal-divider.component.scss'],
})
export class HorizontalDividerComponent {
  @Input() inset = false;
}
